export const descriptionConstants = {
  GETALL_REQUEST: 'DESCRIPTIONS_GETALL_REQUEST',
  GETALL_SUCCESS: 'DESCRIPTIONS_GETALL_SUCCESS',
  GETALL_FAILURE: 'DESCRIPTIONS_GETALL_FAILURE',

  GET_REQUEST: 'DESCRIPTIONS_GET_REQUEST',
  GET_SUCCESS: 'DESCRIPTIONS_GET_SUCCESS',
  GET_FAILURE: 'DESCRIPTIONS_GET_FAILURE',

  ADD_REQUEST: 'DESCRIPTIONS_ADD_REQUEST',
  ADD_SUCCESS: 'DESCRIPTIONS_ADD_SUCCESS',
  ADD_FAILURE: 'DESCRIPTIONS_ADD_FAILURE',

  UPDATE_REQUEST: 'DESCRIPTIONS_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'DESCRIPTIONS_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'DESCRIPTIONS_UPDATE_FAILURE',
}